module.exports = __webpack_public_path__ + "img/xiaolin.503d568a.png";